<template>
    <v-form ref="paymentStepForm">
        <v-layout row wrap>
            <v-flex xs12 class="title">Zahlungsart wählen</v-flex>
            <v-flex xs12>
                <v-item-group>
                    <v-container grid-list-md pa-0>
                        <v-layout wrap fill-height>
                            <v-flex
                                xs12
                                md3
                                v-if="event.payment_methods.includes('PAYPAL')"
                            >
                                <v-item :disabled="paymentTypesDisabled">
                                    <v-card
                                        slot-scope="{ active, toggle }"
                                        :color="active ? 'primary' : ''"
                                        :class="'pa-2' + (paymentTypesDisabled ? ' grey elevation-0 see-through' : '')"
                                        height="100%"
                                        @click="selectPayment(toggle, 'paypal')"
                                        :disabled="paymentTypesDisabled">
                                        <v-img
                                            class="white--text"
                                            height="40"
                                            contain
                                            src="/images/pp-logo.png"
                                        >
                                        </v-img>
                                        <v-card-text>
                                            <div class="subheading">PayPal</div>
                                            <div class="caption">Bezahlen Sie mit Ihrem PayPal Account</div>
                                        </v-card-text>
                                    </v-card>
                                </v-item>
                            </v-flex>
                            <v-flex
                                xs12
                                md3
                                v-if="event.payment_methods.includes('CREDIT_CARD')"
                            >
                                <v-item :disabled="paymentTypesDisabled">
                                    <v-card
                                        slot-scope="{ active, toggle }"
                                        :color="active ? 'primary' : ''"
                                        :class="'pa-2' + (paymentTypesDisabled ? ' grey elevation-0 see-through' : '')"
                                        height="100%"
                                        @click="selectPayment(toggle, 'creditcard')"
                                        :disabled="paymentTypesDisabled">
                                        <v-img
                                            class="white--text"
                                            height="40"
                                            contain
                                            src="/images/cc-logo.png"
                                        >
                                        </v-img>
                                        <v-card-text>
                                            <div class="subheading">Kreditkarte</div>
                                            <div class="caption">Zahlungsabwicklung via PayPal, kein Account
                                                benötigt
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-item>
                            </v-flex>
                            <v-flex
                                xs12
                                md3
                                v-if="event.payment_methods.includes('SEPA')"
                            >
                                <v-item :disabled="paymentTypesDisabled">
                                    <v-card
                                        slot-scope="{ active, toggle }"
                                        :color="active ? 'primary' : ''"
                                        :class="'pa-2' + (paymentTypesDisabled ? ' grey elevation-0 see-through' : '')"
                                        height="100%"
                                        @click="selectPayment(toggle, 'sepa')"
                                        :disabled="paymentTypesDisabled">
                                        <v-img
                                            class="white--text"
                                            height="40"
                                            contain
                                            src="/images/bank-logo.png"
                                        >
                                        </v-img>
                                        <v-card-text>
                                            <div class="subheading">Lastschrift</div>
                                            <div class="caption">Zahlungsabwicklung via PayPal, kein Account
                                                benötigt
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-item>
                            </v-flex>
                            <v-flex
                                xs12
                                md3
                                v-if="event.payment_methods.includes('INVOICE')"
                            >
                                <v-item :disabled="paymentTypesDisabled">
                                    <v-card
                                        slot-scope="{ active, toggle }"
                                        :color="active ? 'primary' : ''"
                                        :class="'pa-2' + (paymentTypesDisabled ? ' grey elevation-0 see-through' : '')"
                                        height="100%"
                                        @click="selectPayment(toggle, 'invoice')"
                                        :disabled="paymentTypesDisabled">
                                        <div
                                            style="height:40px"
                                        >
                                        </div>
                                        <v-card-text>
                                            <div class="subheading">Kauf auf Rechnung</div>
                                            <div class="caption"></div>
                                        </v-card-text>
                                    </v-card>
                                </v-item>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-item-group>
            </v-flex>
            <v-flex xs12 class="title">Coupon einlösen</v-flex>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex grow>
                        <s-text-field
                            v-model="tmpCoupon"
                            label="Coupon"
                            :disabled="couponDisabled"
                        ></s-text-field>
                    </v-flex>
                    <v-flex shrink>
                        <v-btn :loading="ticketsLoading" :disabled="couponDisabled" @click="applyCoupon(tmpCoupon)">
                            Einlösen
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-form ref="agbForm" v-model="agbValid">
                    <v-checkbox
                        v-model="agb"
                        :rules="rules.agb">
                        <span slot="label">Hiermit bestätigen Sie unsere <a
                            @click.prevent.stop="$store.commit('setTerms', true)">AGB</a> und <a
                            @click.prevent.stop="$store.commit('setPrivacyPolicy', true)"> Datenschutzrichtlinien</a> gelesen zu haben und akzeptieren diese.
                        </span>
                    </v-checkbox>
                </v-form>
            </v-flex>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex shrink>
                        <button-previous :disabled="buttonsDisabled"></button-previous>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                        <button-next :loading="submitting" :disabled="buttonsDisabled" @click="submit()">
                            {{orderButtonTitle}}
                        </button-next>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "PaymentStep",
        data() {
            return {
                tmpCoupon: '',
                agb: false,
                agbValid: false,
                rules: this.$validation.create({
                        agb: ['requireBoolean', 'requireTrue'],
                    }
                )
            }
        },
        computed: {
            ...mapState('form', [
                'event',
                'isFree',
                'tickets',
                'invoiceRecipient',
                'attendees',
                'coupon',
                'paymentType',
                'ticketsLoading',
                'submitting',
            ]),
            paymentTypesDisabled() {
                return this.isFree || this.submitting;
            },
            couponDisabled() {
                return this.ticketsLoading || this.submitting;
            },
            buttonsDisabled() {
                return this.ticketsLoading || this.submitting;
            },
            orderButtonTitle() {
                return !this.isFree ? 'Kostenpflichtig bestellen' : 'Jetzt bestellen';
            }
        },
        methods: {
            ...mapMutations('form', [
                'setPaymentType',
                'setSubmitting',
            ]),
            ...mapActions('form', [
                'applyCoupon',
                'setError',
            ]),
            selectPayment(toggle, paymentType) {
                if (!this.isFree) {
                    toggle();
                    this.setPaymentType(paymentType);
                }
            },
            submit() {
                if (!this.isFree && !this.paymentType) {
                    this.setError('Bitte wählen Sie eine Zahlungart aus.');
                    return;
                }
                if (!this.$refs.agbForm.validate()) {
                    this.setError('Bitte stimmen Sie den AGB und Datenschutzrichtlinien zu.');
                    return;
                }
                this.setSubmitting(true);
                axios.post('/checkout/process', {
                    invoiceRecipient: this.invoiceRecipient,
                    attendees: this.attendees,
                    tickets: this.tickets,
                    coupon: this.coupon,
                    event: this.event,
                    paymentType: this.paymentType,
                }).then((response) => {
                    if (response.data) {
                        window.location.href = response.data;
                    } else {
                        this.setError('Es ist ein unerwarteter Fehler aufgetreten.');
                        this.setSubmitting(false);
                    }
                }).catch((e) => {
                    this.setError('Es ist ein unerwarteter Fehler aufgetreten.');
                    this.setSubmitting(false);
                });
            },
        },
    }
</script>

<style scoped>
    .see-through {
        opacity: 0.2;
    }
</style>
